module.exports = __webpack_public_path__ + "img/subjects.6ea48ee4.svg";